(function () {
  if (window.__pdfLookupTableInit) return;
  window.__pdfLookupTableInit = true;

  function getCellValue(tr, idx) {
    return tr.children[idx].innerText || tr.children[idx].textContent;
  }

  function comparer(idx, asc) {
    return function (a, b) {
      var v1 = getCellValue(asc ? a : b, idx);
      var v2 = getCellValue(asc ? b : a, idx);
      if (v1 !== "" && v2 !== "" && !isNaN(v1) && !isNaN(v2)) {
        return v1 - v2;
      }
      return v1.toString().localeCompare(v2);
    };
  }

  // Delegated on document (not the individual inputs/<th>) so this keeps
  // working even if the theme rewraps the <table> (e.g. table-wrapper for
  // responsive/accessibility) after this script runs, and so a single
  // script load handles every pdf-lookup instance on the page.
  document.addEventListener("input", function (e) {
    var input = e.target.closest(".pdf-lookup__search-input");
    if (!input) return;

    var wrapper = input.closest("[data-pdf-lookup]");
    var table = wrapper.querySelector(".pdf-lookup__table");
    var filter = input.value.toUpperCase();

    Array.from(table.querySelectorAll("tbody tr")).forEach(function (tr) {
      // Search every column except the last (Download button, no text of its
      // own) — today that's Name + Brand — instead of just the first cell.
      var searchableCells = Array.from(tr.children).slice(0, -1);
      var text = searchableCells
        .map(function (td) {
          return td.textContent || td.innerText || "";
        })
        .join(" ")
        .toUpperCase();
      tr.style.display = text.indexOf(filter) > -1 ? "" : "none";
    });
  });

  document.addEventListener("click", function (e) {
    var th = e.target.closest(".pdf-lookup__table th");
    if (!th) return;

    var table = th.closest(".pdf-lookup__table");
    var ths = Array.from(table.querySelectorAll("th"));
    var idx = ths.indexOf(th);
    var ascending = th.dataset.asc !== "true";
    ths.forEach(function (otherTh) {
      delete otherTh.dataset.asc;
    });
    th.dataset.asc = ascending;

    var tbody = table.querySelector("tbody");
    Array.from(tbody.querySelectorAll("tr"))
      .sort(comparer(idx, ascending))
      .forEach(function (tr) {
        tbody.appendChild(tr);
      });
  });
})();
